import React from "react";
import { ButtonProps as MuiButtonProps } from "@mui/material";
import { ButtonSize, StyledButton } from "./Button.styles";
import { ColorPalette } from "../../../theme";

interface ButtonProps extends Omit<MuiButtonProps, "children"> {
  label: string;
  size: ButtonSize;
  backgroundColor?: keyof ColorPalette;
  textColor?: keyof ColorPalette;
  reverse?: boolean;
}

export const Button = (props: ButtonProps): React.ReactElement => {
  const {
    label,
    size,
    backgroundColor,
    textColor,
    reverse,
    ...muiButtonProps
  } = props;

  return (
    <StyledButton
      {...muiButtonProps}
      size={size}
      $backgroundColor={backgroundColor}
      $textColor={textColor}
      $reverse={reverse}
    >
      {label}
    </StyledButton>
  );
};
